"use client";
import { useFormState, useFormStatus } from "react-dom";
import { login } from "@/app/[locale]/auth/login";
import {useLocale, useTranslations} from "next-intl";
import { useEffect } from "react";
import toast from "react-hot-toast";
import Link from "next/link";
import { SignInIcon } from "@/icons/signInIcon";
import AppleSignInButton from "@/components/AppleSingIn";
import GoogleSigninButton from "@/components/GoogleSignin";
import MyGoogleSigninButton from "@/components/GoogleSignin";


const SignInPage = () => {
  // const {
  //   handleSubmit,
  //   register,
  //   getValues,
  //   reset,
  //   formState: { errors, isSubmitting, isDirty, isValid },
  // } = useForm<UpdateUserFormState>({
  //   resolver: zodResolver(UpdateUserSchema),
  //   defaultValues: userData,
  //   mode: "all",
  // });

  const [state, action] = useFormState(login, {
    email: "",
    password: "",
  });
  const { pending } = useFormStatus();
  const t = useTranslations();

  useEffect(() => {
    if (state && state.error) {
      toast.error(state.error);
    }


  }, [state]);


  return (
    <section className="relative z-10 overflow-hidden pb-16 pt-36 md:pb-20 lg:pb-28 lg:pt-[180px]">
      <div className="container">
        <div className="-mx-4 flex flex-wrap">
          <div className="w-full px-4">
            <div className="shadow-three dark:bg-dark mx-auto max-w-[500px] rounded bg-white px-6 py-10 sm:p-[60px]">
              <h3 className="mb-3 text-center text-2xl font-bold text-black dark:text-white sm:text-3xl">
                {/*Sign in to your account*/}
                {t("sign_in")}
              </h3>
              {/*<p className="text-body-color mb-11 text-center text-base font-medium">*/}
              {/*  Login to your account for a faster checkout.*/}
              {/*</p>*/}

              <form action={action}>
                <div className="mb-8">
                  <label
                    htmlFor="email"
                    className="text-dark mb-3 block text-sm dark:text-white"
                  >
                    {t("email")}
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder={t("email")}
                    className="border-stroke text-body-color dark:text-body-color-dark dark:shadow-two w-full rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base outline-none transition-all duration-300 focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:focus:border-primary dark:focus:shadow-none"
                  />
                  {state?.errors?.email && (
                    <p className="text-sm text-red-500">{state.errors.email}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="password"
                    className="text-dark mb-3 block text-sm dark:text-white"
                  >
                    {t("password")}
                  </label>
                  <input
                    type="password"
                    name="password"
                    placeholder={t("password")}
                    className="border-stroke text-body-color dark:text-body-color-dark dark:shadow-two w-full rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base outline-none transition-all duration-300 focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:focus:border-primary dark:focus:shadow-none"
                  />
                  {state?.errors?.password && (
                    <p className="text-sm text-red-500">
                      {state.errors.password}
                    </p>
                  )}

                </div>
                 <div className="mb-8 flex flex-col justify-between sm:flex-row sm:items-center">
                   <div>
                      <Link
                        href={`/forgot-password`}
                        className="text-[#5AC2E7] underline"
                      >
                        {t('forgot_password')}
                      </Link>
                    </div>
                  </div>

                <div className="mb-6">
                  <button
                    aria-disabled={pending}
                    type="submit"
                    className="shadow-submit dark:shadow-submit-dark mt-4 flex w-full items-center justify-center rounded-sm bg-primary px-9 py-4 text-base font-medium text-white duration-300 "
                  >
                    {pending ? "Submitting..." : `${t("sign_in")}`}
                  </button>
                </div>
              </form>
              <div className="relative my-10 flex w-full items-center justify-center">
                <div className="absolute left-0 z-10 h-px w-full bg-gray-200"></div>
                <p className="relative z-20 mb-0 inline-flex items-center justify-center bg-white px-5 text-gray-500">
                  OR LOG IN WITH
                </p>
              </div>
              <div className="flex justify-center gap-12 pb-5">
                <MyGoogleSigninButton/>
                <AppleSignInButton />
              </div>
              <p className="text-body-color text-center text-base font-medium">
                {t("dont_have_an_account")}{" "}
                <Link href="/signup" className="text-primary hover:underline">
                  {t("sign_up")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <SignInIcon />
    </section>
  );
};

export default SignInPage;
